const EMPTY_OBJECT = Object.freeze({})
const EMPTY_ARRAY = Object.freeze([])
const MAX_NUMBER = Number.MAX_SAFE_INTEGER

export { EMPTY_OBJECT, EMPTY_ARRAY, MAX_NUMBER }
